<template>
  <v-dialog v-model="dialog" persistent max-width="450">
    <v-card>
      <v-toolbar color="primary" dense dark>
        <v-toolbar-title>Exportação</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click="close">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-container fluid>
        <v-row align-content="center" justify="space-around" class="icons-export">
          <v-col sm="5">
            <v-icon size="100" v-on:click="onexport('xlsx')">fas fa-file-excel</v-icon>
          </v-col>
          <v-col sm="5">
            <v-icon size="100" v-on:click="onexport('csv')">fas fa-file-csv</v-icon>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import XLSX from 'xlsx';
import { sleep } from '@/helpers/page';

export default {
  props: {
    dialog: { type: Boolean, default: false },
    page: { type: String, required: true },
    mode: { type: String },
    model: { type: Array },
    headers: { type: Array }
  },

  methods: {
    async close() {
      await sleep(100);
      this.$emit('closeDialogExport');
    },

    onexport(extension) {
      let headers = [];
      let formatedModel = [];
      let workbook = XLSX.utils.book_new();

      for (let item in this.model[0]) {
        let field = this.headers.find(header => header.value === item);
        field && headers.push({ value: item, desc: field.text });
      }

      for (let item of this.model) {
        let newItem = {};
        for (let header of headers) {
          newItem[header.desc] = item[header.value];
        }
        formatedModel.push(newItem);
      }

      XLSX.utils.book_append_sheet(workbook, XLSX.utils.json_to_sheet(formatedModel));
      XLSX.writeFile(workbook, `${this.page.charAt(0).toUpperCase() + this.page.slice(1)}-${Date.now()}.${extension}`);
    }
  },

  watch: {
    dialog(val) {
      if (!val) this.close();
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  overflow: hidden;
}

.icons-export {
  div[class*='col'] {
    text-align: center;
  }
  .v-icon {
    cursor: pointer;
    transition: 0.6s;
  }
  &:hover {
    .v-icon {
      opacity: 0.5;
      transition: 0.6s;
      &:hover {
        opacity: 1;
        transition: 0.6s;
      }
    }
  }
}
</style>
